export default "__VITE_ASSET__D_2CBRCD__"